import { render } from "./VFormGroupInputSwitch.vue?vue&type=template&id=76a8e18e&scoped=true&ts=true"
import script from "./VFormGroupInputSwitch.vue?vue&type=script&lang=ts"
export * from "./VFormGroupInputSwitch.vue?vue&type=script&lang=ts"

import "./VFormGroupInputSwitch.vue?vue&type=style&index=0&id=76a8e18e&lang=scss&scoped=true"

import exportComponent from "/opt/atlassian/pipelines/agent/build/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-76a8e18e"]])

export default __exports__